import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useHistory } from 'react-router';
import { HeaderWithDescription } from '../../../../modules/common/headerWithDescription/HeaderWithDescription';
import { SpaceBetweenLayout } from '../../../../modules/common/layouts/spaceBetweenLayout/SpaceBetweenLayout';
import { ICurrentWorkspaceStore } from '../../../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { DisabledWhenPolicyExceeded } from '../../../containers/DisabledWhenPolicyExceeded';
import { EnableFor } from '../../../containers/EnableForRole';
import { Home } from '../../../routes/config/Home';
import { useDatasetPermissions } from '../datasets.permissions';

export const DatasetsHeaderContainer = observer((): ReactElement => {
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const { t } = useTranslator();
  const history = useHistory();
  const canCreate = useDatasetPermissions().canCreateDataset();

  const handleClick = (): void => {
    history.push(Home.Datasets.Create.withParams({ datasetDraftId: '', workspaceId: currentWorkspaceStore.currentWorkspace.id }));
  };

  return (
    <SpaceBetweenLayout>
      <HeaderWithDescription header={t('your_datasets')} />
      <DisabledWhenPolicyExceeded limitType='space'>
        <EnableFor hasPermission={canCreate}>
          <Button onClick={handleClick}>{t('create_dataset')}</Button>
        </EnableFor>
      </DisabledWhenPolicyExceeded>
    </SpaceBetweenLayout>
  );
});
